import React from 'react';


import {GameCenterHeaderModuleController} from "../../../game-center-header-module.controller";
import styles from "../../../styles/game-center-header-competitor.module.scss";
import classNames from "classnames";
import {BaseProps} from "../../../../../../../infrastructure/models/props/base-props";

export class GameCenterHeaderModuleDetailsCompetitorRankingProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleDetailsCompetitorRanking = ({competitor}: GameCenterHeaderModuleDetailsCompetitorRankingProps) => {
  return (
    competitor.ranking ?
      <div className={classNames(styles.competitor_ranking)}>
        {competitor.ranking?.toString()}
      </div> : null
  )
};
